import React, { useState } from 'react';
import { array, func } from 'prop-types';

import BackToTop from './BackToTop';
import Hotels from './Hotels';

function SeeAllHotels({ filtered, scrollTop }) {
  const [numberOfHotels, setNumberOfHotels] = useState(0);

  function onBlur() {}

  function onChange(e) {
    console.log(filtered);

    console.log(e.target.options[e.target.selectedIndex].value);
  }

  return (
    <div className="grid-x align-center">
      <div className="cell small-12 see-all-hotels">
        <div className="grid-x see-all-hotels-wrap">
          <div className="cell small-12 large-9 showing-all-hotels">
            {filtered.length !== 1 ? (
              <p className="see-all-title">
                Showing all {numberOfHotels} Historic Hotels Worldwide
              </p>
            ) : (
              <div className="grid-x">
                <div className="cell large-6 filtered-hotels">
                  <h2 className="filtered-title">Location</h2>
                </div>
                {filtered[0].data && (
                  <div className="cell large-6 filtered-hotels">
                    <h2 className="filtered-title">Hotel</h2>
                  </div>
                )}
              </div>
            )}
          </div>
          {filtered.length !== 1 && (
            <div className="cell small-12 large-3 filter-by">
              <select
                onChange={onChange}
                onBlur={onBlur}
                aria-label="Filter your results"
                className="filter-select"
              >
                <option value="0">Filter your results</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
              </select>
            </div>
          )}
        </div>
        <div className="find-a-hotel-suggestions gridx">
            <Hotels
              filtered={filtered}
              setNumberOfHotels={setNumberOfHotels}
              showAll={true}
            />
        </div>
        {filtered.length !== 1 && <BackToTop scrollTop={scrollTop} />}
      </div>
    </div>
  );
}

SeeAllHotels.propTypes = {
  filtered: array.isRequired,
  scrollTop: func.isRequired
};

export default SeeAllHotels;
